"use strict";

module.exports = require("./ImageEditor.js");